<div class="roster-pay-page">
  <div class="roster-pay-wrap">
    @if (isLoading) {
      <div class="state-card">
        <mat-spinner diameter="48"></mat-spinner>
        <p>{{ statusMessage }}</p>
      </div>
    } @else if (success) {
      <div class="state-card success">
        <mat-icon class="ok-icon" aria-hidden="true">check_circle</mat-icon>
        <h1>Payment received</h1>
        <p class="eyebrow">Roster payment updated</p>
        <p class="lead">
          Thank you — your payment of
          <strong>{{ amountPaid | currency : "CAD" }}</strong>
          @if (teamName) {
            for <strong>{{ teamName }}</strong>
          }
          @if (seasonName) {
            ({{ seasonName }})
          }
          has been recorded.
        </p>
        <div class="roster-pay-actions">
          @if (returnToDashboard) {
            <a
              class="roster-pay-btn roster-pay-btn-primary"
              routerLink="/my-dashboard/payments"
              [queryParams]="{ season_id: seasonId, team_id: teamId }"
            >
              Back to my payments
            </a>
          } @else if (teamId) {
            <a
              class="roster-pay-btn roster-pay-btn-primary"
              [routerLink]="['/team', teamId, 'roster']"
              [queryParams]="returnTab ? { tab: returnTab } : null"
            >
              @if (returnTab === 'payments') {
                Back to team payments
              } @else {
                Back to team roster
              }
            </a>
          } @else {
            <a class="roster-pay-btn roster-pay-btn-primary" routerLink="/">Home</a>
          }
        </div>
        <p class="trust-note">If your balance does not refresh immediately, reload the payments page after a few seconds.</p>
      </div>
    } @else {
      <div class="state-card warn">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <h1>{{ statusMessage }}</h1>
        <div class="roster-pay-actions">
          <a class="roster-pay-btn roster-pay-btn-secondary" routerLink="/">Home</a>
        </div>
      </div>
    }
  </div>
</div>
